import { render } from "./Items.vue?vue&type=template&id=18d46570"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"
script.render = render

export default script